import { Action } from 'redux';

import CommunicationData from '../interfaces/CommunicationData';
import ActionFetchCommunicationSuccess from '../interfaces/actions/ActionFetchCommunicationSuccess';

import * as Const from '../constants';

export const fetchCommunicationInit = (): Action => {
  return {
    type: Const.FETCH_COMMUNICATION_INIT,
  };
};

export const fetchCommunicationPending = (): Action => {
  return {
    type: Const.FETCH_COMMUNICATION_PENDING,
  };
};

export const fetchCommunicationSuccess = (payload: CommunicationData[]): ActionFetchCommunicationSuccess => {
  return {
    type: Const.FETCH_COMMUNICATION_SUCCESS,
    payload,
  };
};

export const fetchCommunicationFail = (): Action => {
  return {
    type: Const.FETCH_COMMUNICATION_FAIL,
  };
};
